import React, { Component } from 'react';

// пока пустой указатель, инициализируем позже, когда создатся экземпляр реакт-класса
let errorHandler = null;

// Обновляем состояние баннера на новый текст ошибки
export function setAlert (msg){
    if (errorHandler === null)
    {
        if( msg !== null )
            return console.log("Error: setAlert() called before instantiating <Alert />, ignored. Message: ", msg);
        else
            return;
    }
    errorHandler(msg);
}

// класс показывает баннер с ошибкой, если она установлена не в null
export default class Alert extends Component {
    constructor(props) {
        super(props);

        this.state = { errormsg: null };

        if ( errorHandler !== null )
            console.log("Warning: there can be only one instance of <Alert /> in application.");
        errorHandler = this.setMsg.bind(this);
    }

    componentWillUnmount() {
        errorHandler = null;
    }    

    setMsg(msg) {
        this.setState({ errormsg: msg });
    }

    render () {
        if (this.state.errormsg === null)
            return ('');
        else
            return (<aside className="fixed-bottom bg-danger border border-white text-white p-2" role="alert"> {this.state.errormsg} </aside>);
    }
}
